import { get } from '.';

export function GetVehicleTrimDefinitions(options = {}) {
	return get<any>("/app/api/vehicle_trim_definitions", options);
}
